import React from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { Button } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import {Paper} from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';

const columns = [
    // { id: 'first_name', label: 'First Name' },
    { id: 'full_name', label: 'Name' },
    { id: 'email', label: 'Email' },
    { id: 'company', label: 'Company' },
    { id: 'rolename', label: 'Role' },
  ];

const DashboardUsers = ({usersList}) => {

  return (
    <TableContainer 
      sx={{ 
        overflowY: 'hidden',
        height: '100%',  
        borderRadius:'30px',
        boxShadow: '0px 0px 15px 1px #D1D9E7',
        "&::-webkit-scrollbar": {
          height: '4px',
          width: '4px',
          background: 'gray',
        },
        "&::-webkit-scrollbar-track": {
          background: '#f1f1f1'
        },
        "&::-webkit-scrollbar-thumb": {
          background: '#888',
          borderRadius: '8px'
        },
        "&::-webkit-scrollbar-thumb:hover": {
          background: 'rgb(30,60,114)'
        },
        "&::-webkit-scrollbar-thumb:horizontal": {
          borderRadius: '10px'
        }
      }} 
      component={Paper}
    >
      <Table stickyHeader aria-label="sticky table">
        <caption>
          <Button
            component={Link} to="/web/users"
            sx={{ float: 'right' }}
            //variant="contained"
            size="small"

          >View All <KeyboardArrowRightIcon /></Button>
        </caption>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell
                key={column.id}
                align={column.align}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {usersList?.data?.length > 0 ? usersList?.data?.map((row, i) => {
            return (
              <TableRow hover role="checkbox" tabIndex={-1} key={i}>
                {columns.map((column) => {
                  const value = row[column.id];
                  return (
                    <TableCell key={column.id} align={column.align}>
                      {column.format && typeof value === 'number'
                        ? column.format(value) :
                        column.id === 'rolename' ? row?.rolename?.charAt(0).toUpperCase() + row?.rolename?.slice(1)
                          :
                          value}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          }) : <TableRow><TableCell colSpan={4}>No Data Available. </TableCell></TableRow>}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DashboardUsers